module.exports = __webpack_public_path__ + "static/media/81ca208a-5e26-4bdd-a0c9-2104c9c2fea4.5510cc7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/81ca208a-5e26-4bdd-a0c9-2104c9c2fea4.png
// module id = 1479
// module chunks = 0